(function () {
  if (window.MiisB2BPriceTableLoaded) return;
  window.MiisB2BPriceTableLoaded = true;

  const MONEY_PATTERN = /\d{1,3}(?:[.\s]\d{3})+/g;
  const RETRY_DELAYS = [0, 250, 600, 1200, 2200, 4000];

  function parseMoney(value) {
    const normalized = String(value || '').replace(/[^\d]/g, '');
    const amount = Number.parseInt(normalized, 10);
    return Number.isFinite(amount) && amount > 0 ? amount : null;
  }

  function formatCOP(value) {
    return Math.round(value).toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  function visiblePriceValues(priceSource) {
    const values = [];
    const priceNodes = priceSource.querySelectorAll(
      '.f-price-item, .money, [data-product-price], [data-price], [bss-b2b-price], [bss-b2b-product-price], [bss-b2b-product-compare-price], [class*="bss"][class*="price"]'
    );

    priceNodes.forEach((node) => {
      if (!node.getClientRects().length) return;
      const matches = (node.textContent || '').match(MONEY_PATTERN) || [];
      matches.forEach((match) => {
        const amount = parseMoney(match);
        if (amount) values.push(amount);
      });
    });

    if (!values.length) {
      const matches = (priceSource.innerText || '').match(MONEY_PATTERN) || [];
      matches.forEach((match) => {
        const amount = parseMoney(match);
        if (amount) values.push(amount);
      });
    }

    return Array.from(new Set(values));
  }

  function updateTable(table) {
    const sectionId = table.id.replace('b2b-price-table-', '');
    const mayorista = document.getElementById(`b2b-mayorista-${sectionId}`);
    const silver = document.getElementById(`b2b-silver-${sectionId}`);
    const gold = document.getElementById(`b2b-gold-${sectionId}`);
    if (!mayorista || !silver || !gold) return false;

    const priceRoot = document.getElementById(`price-${sectionId}`);
    if (!priceRoot) return false;

    const values = visiblePriceValues(priceRoot);
    if (!values.length) return false;

    const wholesaleBase = Math.min.apply(null, values);

    mayorista.textContent = formatCOP(wholesaleBase);
    silver.textContent = formatCOP(wholesaleBase * 0.9);
    gold.textContent = formatCOP(wholesaleBase * 0.83);
    table.dataset.b2bSourcePrice = String(wholesaleBase);
    table.removeAttribute('aria-busy');
    return true;
  }

  function initializeTable(table) {
    if (table.dataset.miisB2BReady === 'true') return;
    table.dataset.miisB2BReady = 'true';
    table.setAttribute('aria-busy', 'true');

    const sectionId = table.id.replace('b2b-price-table-', '');
    const priceRoot = document.getElementById(`price-${sectionId}`);
    if (!priceRoot) return;

    let timer;
    const scheduleUpdate = function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        updateTable(table);
      }, 120);
    };

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(priceRoot, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });

    RETRY_DELAYS.forEach(function (delay) {
      window.setTimeout(scheduleUpdate, delay);
    });

    document.addEventListener('variant:change', scheduleUpdate);
    document.addEventListener('product:variant-change', scheduleUpdate);
  }

  function initialize() {
    document.querySelectorAll('.b2b-price-table[id^="b2b-price-table-"]').forEach(initializeTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
